// extracted by mini-css-extract-plugin
module.exports = {"AddButton":"AddButton_AddButton__1MmvN","AddIcon":"AddButton_AddIcon__1gzW4"};